import { ClearIndicator } from './ClearIndicator';

export default ClearIndicator;
